import request from "superagent";
import settings from "settings";

import { TYPE_GLOBAL_SEARCH } from "../Actions/ActionClanRating";

export const AUTOCOMPLETE_CLEAR_RESULT = 'AUTOCOMPLETE_CLEAR_RESULT';
export const AUTOCOMPLETE_CLEAR_STATE = 'AUTOCOMPLETE_CLEAR_STATE';
export const AUTOCOMPLETE_FETCH_FAILED = 'AUTOCOMPLETE_FETCH_FAILED';
export const AUTOCOMPLETE_FETCH_OK = 'AUTOCOMPLETE_FETCH_OK';
export const AUTOCOMPLETE_START_FETCHING = 'AUTOCOMPLETE_START_FETCHING';


export const clearAutocompleteState = () => {
  return {
    type: AUTOCOMPLETE_CLEAR_STATE
  };
};

export const clearResult = () => {
  return {
    type: AUTOCOMPLETE_CLEAR_RESULT
  };
};

export const fetchAutompleteResult = (term, type) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(clearResult());

    if (term.length < settings.search.minChars) {
      return;
    }

    let url;
    let query = {};

    const realm = state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH;

    if (type === 'clansRating') {
      url = state.urls.ladderClanSearchAutocomplete.replace('{query}', term);
      url = `${url}&season=${state.clansRating.currentSeason}&realm=${realm}`;
    } else {
      url = state.urls.searchAutocomplete;
      query = {
        search: term,
        type: 'clans'
      };
    }

    dispatch(startFetching());

    let req = request.get(url).query(query);
    req.then(response => {
      const data = Object.assign({}, response.body, { term });
      dispatch(processSuccessfulResponse(data));
    }, error => {
      dispatch(processFailedResponse(error));
    });
    return req;
  };
};

export const processFailedResponse = error => {
  return {
    type: AUTOCOMPLETE_FETCH_FAILED,
    error
  };
};

export const processSuccessfulResponse = data => {
  return {
    type: AUTOCOMPLETE_FETCH_OK,
    data
  };
};

export const startFetching = () => {
  return {
    type: AUTOCOMPLETE_START_FETCHING
  };
};